
  <div class="d-flex flex-wrap align-items-center gap-4 justify-content-between">
    <div class="input-group mb-4 w-50 mt-4">
      <span class="input-group-text bg-white border-end-0">
        <i class="fa-solid fa-magnifying-glass text-muted"></i>
      </span>
      <input type="text" [(ngModel)]="searchTerm" class="form-control border-start-0"
        placeholder="Filter by service or region name" (ngModelChange)="onSearch()" />
    </div>

    <div class="d-flex flex-wrap align-items-center gap-4">
       <div class="dropdown">
    <button class="btn btn-outline-primary dropdown-toggle shadow-sm" data-bs-toggle="dropdown">
      Breakpoints: <i class="fa-solid fa-layer-group"></i>
    </button>
    <div class="dropdown-menu p-3 shadow-lg rounded-3" style="min-width: 220px;">
      <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" id="regionCheck" [(ngModel)]="breakpoints.region">
          <label class="form-check-label" for="regionCheck">Region</label>
      </div>
      <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" id="tagNameCheck1" [(ngModel)]="breakpoints.product_family">
          <label class="form-check-label" for="tagNameCheck1">Product Family</label>
      </div>
      <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" id="tagNameCheck2" [(ngModel)]="breakpoints.line_item">
          <label class="form-check-label" for="tagNameCheck2">Line Item</label>
      </div>
      <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="clearPreferences()">Clear</button>
      <button type="button" class="btn btn-primary" (click)="onSubmitClick()">Submit</button>
      </div>
    </div>
  </div>
      <button class="btn btn-outline-primary" (click)="toggleExpandAll()">
        <i class="fa" [ngClass]="isExpandedAll ? 'fa-square-minus' : 'fa-square-plus'"></i>
        {{ isExpandedAll ? 'Minimize All' : 'Expand All' }}
      </button>
    </div>
  </div>
<!--  
<table class="table table-striped table-bordered align-middle">
  <thead class="table-light">
    <tr>
      <th style="width: 40%">Name / Hierarchy</th>
      <th style="width: 20%" class="text-end">Usage Amount</th>
      <th style="width: 20%" class="text-end">Base Cost (₹)</th>
      <th style="width: 20%" class="text-end">Final Cost (₹)</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngIf="!filteredList?.length">
      <td colspan="4" class="text-center text-muted py-3">No data found</td>
    </tr>

    <ng-container *ngFor="let account of paginatedList">
      <tr style="border-bottom: 1px solid #dee2e6;">
        <td>
          <span (click)="toggle(account)" class="d-inline-flex align-items-center cursor-pointer">
            <i class="fa" [ngClass]="account.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
          </span>
          {{ account.account_id }}
        </td>
        <td class="text-end"></td>
        <td class="text-end"><strong>{{ account.base_cost | number: '1.2-2' }}</strong></td>
        <td class="text-end"><strong>{{ account.final_cost | number: '1.2-2' }}</strong></td>
      </tr>

      <ng-container *ngIf="account.expanded">

        <ng-container *ngIf="account.aws">
          <tr style="border-bottom: 1px solid #dee2e6;">
            <td style="padding-left: 40px; cursor: pointer;" (click)="account.aws.expanded = !account.aws.expanded">
              <i class="fa me-1" [ngClass]="account.aws.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
              <strong>AWS</strong>
            </td>
            <td class="text-end"></td>
            <td class="text-end">{{ account.aws.base_cost | number: '1.2-2' }}</td>
            <td class="text-end">{{ account.aws.final_cost | number: '1.2-2' }}</td>
          </tr>

          <ng-container *ngIf="account.aws.expanded && account.aws.services?.length">
            <ng-container *ngFor="let service of account.aws.services">
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding-left: 80px;">{{ service.product_code || service.product_name }}</td>
                <td class="text-end"></td>
                <td class="text-end">{{ service.base_cost | number: '1.2-2' }}</td>
                <td class="text-end">{{ service.final_cost | number: '1.2-2' }}</td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="account.marketplace">
          <tr style="border-bottom: 1px solid #dee2e6;">
            <td style="padding-left: 40px; cursor: pointer;" (click)="account.marketplace.expanded = !account.marketplace.expanded">
              <i class="fa me-1" [ngClass]="account.marketplace.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
              <strong>Marketplace</strong>
            </td>
            <td class="text-end"></td>
            <td class="text-end">{{ account.marketplace.base_cost | number: '1.2-2' }}</td>
            <td class="text-end">{{ account.marketplace.final_cost | number: '1.2-2' }}</td>
          </tr>

          <ng-container *ngIf="account.marketplace.expanded && account.marketplace.services?.length">
            <ng-container *ngFor="let service of account.marketplace.services">
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding-left: 80px;">{{ service.product_code || service.product_name }}</td>
                <td class="text-end"></td>
                <td class="text-end">{{ service.base_cost | number: '1.2-2' }}</td>
                <td class="text-end">{{ service.final_cost | number: '1.2-2' }}</td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>

      </ng-container>
    </ng-container>
  </tbody>
</table>


<div class="d-flex justify-center align-items-center mt-3" *ngIf="totalPages > 1">
      <i class="fa fa-angle-left fa-lg cursor-pointer mx-2" [class.text-muted]="currentPage === 1"
        (click)="goToPreviousPage()"></i>
      <span class="mx-2">Page {{ currentPage }} of {{ totalPages }}</span>
      <i class="fa fa-angle-right fa-lg cursor-pointer mx-2" [class.text-muted]="currentPage >= totalPages"
        (click)="goToNextPage()"></i>
    </div> -->


<table class="table table-striped table-bordered align-middle">
  <thead class="table-light">
    <tr>
      <th style="width: 40%">Name / Hierarchy</th>
      <th style="width: 20%" class="text-end">Usage Amount</th>
      <th style="width: 20%" class="text-end">Base Cost (₹)</th>
      <th style="width: 20%" class="text-end">Final Cost (₹)</th>
    </tr>
  </thead>

  <tbody>
    <!-- No data -->
    <tr *ngIf="!filteredList?.length">
      <td colspan="4" class="text-center text-muted py-3">No data found</td>
    </tr>

    <!-- Account Level -->
    <ng-container *ngFor="let account of paginatedList">
      <tr>
        <td>
          <span (click)="account.expanded = !account.expanded" class="cursor-pointer d-inline-flex align-items-center">
            <i class="fa" [ngClass]="account.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
          </span>
          {{ account.account_id }}
        </td>
        <td class="text-end"></td>
        <td class="text-end"><strong>{{ account.base_cost | number:'1.2-2' }}</strong></td>
        <td class="text-end"><strong>{{ account.final_cost | number:'1.2-2' }}</strong></td>
      </tr>

      <ng-container *ngIf="account.expanded">

        <!-- 🔹 AWS Section -->
        <ng-container *ngIf="account.aws">
          <tr>
            <td style="padding-left: 40px; cursor: pointer;" (click)="account.aws.expanded = !account.aws.expanded">
              <i class="fa me-1" [ngClass]="account.aws.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
              <strong>AWS</strong>
            </td>
            <td class="text-end"></td>
            <td class="text-end">{{ account.aws.base_cost | number:'1.2-2' }}</td>
            <td class="text-end">{{ account.aws.final_cost | number:'1.2-2' }}</td>
          </tr>

          <ng-container *ngIf="account.aws.expanded && account.aws.services?.length">
            <ng-container *ngFor="let service of account.aws.services">

              <!-- Service Level -->
              <tr>
                <td style="padding-left: 80px; cursor: pointer;" (click)="service.expanded = !service.expanded">
                  <i class="fa me-1" [ngClass]="service.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
                  {{ service.product_name || service.product_code }}
                </td>
                <td class="text-end"></td>
                <td class="text-end">{{ service.base_cost | number:'1.2-2' }}</td>
                <td class="text-end">{{ service.final_cost | number:'1.2-2' }}</td>
              </tr>

              <!-- Regions -->
              <ng-container *ngIf="service.expanded && service.regions?.length">
                <ng-container *ngFor="let region of service.regions">
                  <tr>
                    <td style="padding-left: 120px; cursor: pointer;" (click)="region.expanded = !region.expanded">
                      <i class="fa me-1" [ngClass]="region.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
                      {{ region.region }}
                    </td>
                    <td class="text-end"></td>
                    <td class="text-end">{{ region.base_cost | number:'1.2-2' }}</td>
                    <td class="text-end">{{ region.final_cost | number:'1.2-2' }}</td>
                  </tr>

                  <!-- Product Families -->
                  <ng-container *ngIf="region.expanded && region.product_families?.length">
                    <ng-container *ngFor="let pf of region.product_families">
                      <tr>
                        <td style="padding-left: 160px; cursor: pointer;" (click)="pf.expanded = !pf.expanded">
                          <i class="fa me-1" [ngClass]="pf.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
                          {{ pf.product_family }}
                        </td>
                        <td class="text-end"></td>
                        <td class="text-end">{{ pf.base_cost | number:'1.2-2' }}</td>
                        <td class="text-end">{{ pf.final_cost | number:'1.2-2' }}</td>
                      </tr>

                      <!-- Operations -->
                      <ng-container *ngIf="pf.expanded && pf.operations?.length">
                        <ng-container *ngFor="let op of pf.operations">
                          <tr>
                            <td style="padding-left: 200px; cursor: pointer;" (click)="op.expanded = !op.expanded">
                              <i class="fa me-1" [ngClass]="op.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
                              {{ op.operation }}
                            </td>
                            <td class="text-end"></td>
                            <td class="text-end">{{ op.base_cost | number:'1.2-2' }}</td>
                            <td class="text-end">{{ op.final_cost | number:'1.2-2' }}</td>
                          </tr>

                          <!-- Line Items -->
                          <ng-container *ngIf="op.expanded && op.line_items?.length">
                            <ng-container *ngFor="let li of op.line_items">
                              <tr>
                                <td style="padding-left: 240px;">{{ li.line_item }}</td>
                                <td class="text-end">{{ li.total_usage_amount | number:'1.2-2' }}</td>
                                <td class="text-end">{{ li.base_cost | number:'1.2-2' }}</td>
                                <td class="text-end">{{ li.final_cost | number:'1.2-2' }}</td>
                              </tr>
                            </ng-container>
                          </ng-container>

                        </ng-container>
                      </ng-container>

                    </ng-container>
                  </ng-container>

                </ng-container>
              </ng-container>

            </ng-container>
          </ng-container>
        </ng-container>

        <!-- 🔹 Marketplace Section -->
        <ng-container *ngIf="account.marketplace">
          <tr>
            <td style="padding-left: 40px; cursor: pointer;" (click)="account.marketplace.expanded = !account.marketplace.expanded">
              <i class="fa me-1" [ngClass]="account.marketplace.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
              <strong>Marketplace</strong>
            </td>
            <td class="text-end"></td>
            <td class="text-end">{{ account.marketplace.base_cost | number:'1.2-2' }}</td>
            <td class="text-end">{{ account.marketplace.final_cost | number:'1.2-2' }}</td>
          </tr>

          <ng-container *ngIf="account.marketplace.expanded && account.marketplace.services?.length">
            <ng-container *ngFor="let service of account.marketplace.services">

              <!-- Service Level -->
              <tr>
                <td style="padding-left: 80px; cursor: pointer;" (click)="service.expanded = !service.expanded">
                  <i class="fa me-1" [ngClass]="service.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
                  {{ service.product_name || service.product_code }}
                </td>
                <td class="text-end"></td>
                <td class="text-end">{{ service.base_cost | number:'1.2-2' }}</td>
                <td class="text-end">{{ service.final_cost | number:'1.2-2' }}</td>
              </tr>

              <!-- Regions -->
              <ng-container *ngIf="service.expanded && service.regions?.length">
                <ng-container *ngFor="let region of service.regions">
                  <tr>
                    <td style="padding-left: 120px; cursor: pointer;" (click)="region.expanded = !region.expanded">
                      <i class="fa me-1" [ngClass]="region.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
                      {{ region.region }}
                    </td>
                    <td class="text-end"></td>
                    <td class="text-end">{{ region.base_cost | number:'1.2-2' }}</td>
                    <td class="text-end">{{ region.final_cost | number:'1.2-2' }}</td>
                  </tr>

                  <!-- Product Families -->
                  <ng-container *ngIf="region.expanded && region.product_families?.length">
                    <ng-container *ngFor="let pf of region.product_families">
                      <tr>
                        <td style="padding-left: 160px; cursor: pointer;" (click)="pf.expanded = !pf.expanded">
                          <i class="fa me-1" [ngClass]="pf.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
                          {{ pf.product_family }}
                        </td>
                        <td class="text-end"></td>
                        <td class="text-end">{{ pf.base_cost | number:'1.2-2' }}</td>
                        <td class="text-end">{{ pf.final_cost | number:'1.2-2' }}</td>
                      </tr>

                      <!-- Operations -->
                      <ng-container *ngIf="pf.expanded && pf.operations?.length">
                        <ng-container *ngFor="let op of pf.operations">
                          <tr>
                            <td style="padding-left: 200px; cursor: pointer;" (click)="op.expanded = !op.expanded">
                              <i class="fa me-1" [ngClass]="op.expanded ? 'fa-solid fa-square-minus' : 'fa-solid fa-square-plus'"></i>
                              {{ op.operation }}
                            </td>
                            <td class="text-end"></td>
                            <td class="text-end">{{ op.base_cost | number:'1.2-2' }}</td>
                            <td class="text-end">{{ op.final_cost | number:'1.2-2' }}</td>
                          </tr>

                          <!-- Line Items -->
                          <ng-container *ngIf="op.expanded && op.line_items?.length">
                            <ng-container *ngFor="let li of op.line_items">
                              <tr>
                                <td style="padding-left: 240px;">{{ li.line_item }}</td>
                                <td class="text-end">{{ li.total_usage_amount | number:'1.2-2' }}</td>
                                <td class="text-end">{{ li.base_cost | number:'1.2-2' }}</td>
                                <td class="text-end">{{ li.final_cost | number:'1.2-2' }}</td>
                              </tr>
                            </ng-container>
                          </ng-container>

                        </ng-container>
                      </ng-container>

                    </ng-container>
                  </ng-container>

                </ng-container>
              </ng-container>

            </ng-container>
          </ng-container>
        </ng-container>

      </ng-container>
    </ng-container>
  </tbody>
</table>
<div class="d-flex justify-center align-items-center mt-3" *ngIf="totalPages > 1">
      <i class="fa fa-angle-left fa-lg cursor-pointer mx-2" [class.text-muted]="currentPage === 1"
        (click)="goToPreviousPage()"></i>
      <span class="mx-2">Page {{ currentPage }} of {{ totalPages }}</span>
      <i class="fa fa-angle-right fa-lg cursor-pointer mx-2" [class.text-muted]="currentPage >= totalPages"
        (click)="goToNextPage()"></i>
    </div> 